<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><strong class="b">“Dex, wait! Haven’t you forgotten something? Your ring.”</strong></div>
<div class="p"><span>“Keep it,” he said bitingly. “A memento of a failed affair. Unless, of course, you want to pay for it in kind. Unlike the dozens before me, I still have not seen your bedroom.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>This mocking cynicism was the last straw. Flinging the ring at him, she yelled, “Get out! Go, go!”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“No one tells me to leave,” he stated softly.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“Until now,” she shot back.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“Never ever,” he drawled quietly. “And certainly not a devious little girl like you, who doesn’t know whether she wants to jilt me or jump me. I think we really need to know the answer, Bethany. Don’t you?”</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459251816_fm01.vue?5de998c6